<template>
    <div>
        <modal class="bill-detail" :display="modalStatus.billDetail" @modalStatus="closeModal" >
            <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
                <span class="title" slot="title">{{msg.success}}</span>
            </alart-msg>
            <alart-msg :display="alart.error" styleType="error" @alartStatus="alart.error = false">
                <span class="title" slot="title">{{msg.error}}</span>
            </alart-msg>
            <h1>{{billList.houseName}}</h1>
            <div class="bill-detail-wrap" :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                <div class="bill-info">
                    <span class="title">帳單金額</span>
                    <div class="tatal-amount">
                        $   {{toCurrency(billList.totalBillAmount)}}
                    </div>
                    <span class="state blue" v-if="billList.billStatus == 'COMPLETELY_PAID'">已繳</span>
                    <span class="state gray" v-if="billList.billStatus == 'UNPAID'">未繳</span>
                    <span class="state red" v-if="billList.billStatus == 'OVERDUE'">{{checkArrearsDay(billList.arrearsDay)}}</span>
                </div>
                <div class="list">
                    <span class="title">房源地址</span>
                    <span class="content">：{{billList.address}}</span>
                </div>
                <div class="list">
                    <span class="title">收支類別</span>
                    <span class="content">：收入</span>
                </div>
                <div class="list">
                    <span class="title">租客名稱</span>
                    <span class="content">：{{billList.tenantName}}</span>
                </div>
                <div class="list">
                    <span class="title">繳款租期</span>
                    <span class="content">：{{billList.periodStartDate}} ～ {{billList.periodEndDate}}</span>
                </div>
                <div class="list" v-if="billList.billStatus == 'UNPAID'">
                    <span class="title">應收款日</span>
                    <span class="content">：{{billList.periodStartDate}}</span>
                </div>
                <div class="list" v-if="billList.billStatus == 'COMPLETELY_PAID'">
                    <span class="title">繳款日期</span>
                    <span class="content">：{{billList.actualPayTime}}</span>
                </div>
                <div class="list">
                    <span class="title">帳單名稱</span>
                    <span class="content">：{{billList.billName}}</span>
                </div>
                <div class="list">
                    <span class="title">租金</span>
                    <span class="content">
                        ：<span class="num">{{billList.rent?toCurrency(billList.rent):''}}</span>
                    </span>
                </div>
                <div class="list">
                    <span class="title">水費</span>
                    <span class="content num">：
                        <span class="num">{{billList.waterBill?toCurrency(billList.waterBill):''}}</span>
                    </span>
                </div>
                <div class="list">
                    <span class="title">電費</span>
                    <span class="content">：
                        <span class="num">{{billList.electricityBill?toCurrency(billList.electricityBill):''}}</span>
                    </span>
                </div>
                <div class="list">
                    <span class="title">瓦斯費</span>
                    <span class="content">：
                        <span class="num">{{billList.gasBill?toCurrency(billList.gasBill):''}}</span>
                    </span>
                </div>
                <div class="list">
                    <span class="title">網路費</span>
                    <span class="content">：
                        <span class="num">{{billList.internetBill?toCurrency(billList.internetBill):''}}</span>
                    </span>
                </div>
                <div class="list">
                    <span class="title">有線電視</span>
                    <span class="content">：
                        <span class="num">{{billList.tvBill?toCurrency(billList.tvBill):''}}</span>
                    </span>
                </div>
                <div class="list">
                    <span class="title">清潔費</span>
                    <span class="content">：
                        <span class="num">{{billList.cleaningBill?toCurrency(billList.cleaningBill):''}}</span>
                    </span>
                </div>
                <div class="list">
                    <span class="title">停車費</span>
                    <span class="content">：
                        <span class="num">{{billList.parkingBill?toCurrency(billList.parkingBill):''}}</span>
                    </span>
                </div>
                <div class="list">
                    <span class="title">管理費</span>
                    <span class="content">：
                        <span class="num">{{billList.managementBill?toCurrency(billList.managementBill):''}}</span>
                    </span>
                </div>
            </div>
            <div class="btn-group" v-if="billList.billStatus == 'OVERDUE'">
                <button class="default-button confirm" @click="sendMsg()">催款</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';

import { mapGetters } from 'vuex'

import { 
    apiGetBillDetail,
    apiSendMsg,
    apiHadSent
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            billList:{},
            alart: {
                success: false,
                error: false
            },
            msg: {
                success: null,
                error: null,
            }
        }
    },
    props:{
        billId: null,
        phone: null
    },
    mounted (){
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch:{
        billId: function (val) {
            this.getBillDetail(val)
        },
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'billDetail'})
        },
        getBillDetail: function (val) {
            let data = val
            apiGetBillDetail(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.billList = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        sendMsg: function () {
            this.$analytics.logEvent('送出催款', { screen_name: '送出催款'})
            let data = {
                "account": this.phone,
                "title":"",
                "message":"您有一筆租金尚未繳款，請立即開啟確認"
            }

            apiSendMsg(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.alart.success = true
                    this.msg.success = '催款訊息送出成功'
                    this.setHadSent(this.billId)
                    this.closeModal()
                }else{
                    this.alart.error = true
                    this.msg.error = '催款訊息送出失敗'
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        setHadSent: function (billCid) {
            let data = {
                "billCid" : billCid,
                "hadSent" : true
            }

            apiHadSent(data)
            .then(res => {
                if(res.data.status == "SUCCESS"){
                    this.$store.dispatch('getFinancialBillMgtList')
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        checkArrearsDay: function (day) {
            if(day > 0){
                return '欠款'+day+'天'
            }else{
                return '欠款'
            }
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }else{
        //         return 0
        //     }
        // },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        AlartMsg
    }
}
</script>
<style lang="scss"  >
    #modal.bill-detail{
        .modal-content{
            width: 488px;
            padding: 0 !important;
            .detail{
                >h1{
                    padding: 0 32px;
                    margin-top: 32px;
                }
                .bill-detail-wrap{
                    padding: 32px;
                    overflow-x: hidden;
                    max-height: 550px;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .bill-info{
                        position: relative;
                        display: flex;
                        align-items: center;
                        width: 384px;
                        height: 44px;
                        padding: 14px 20px;
                        margin-bottom: 25px;
                        border-radius: 10px;
                        background-color: rgba(255, 255, 255, 0.5);
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        .tatal-amount{
                            padding-left: 20px;
                            letter-spacing: 0.22px;
                            color: #676362;
                            font-size: 20px;
                        }
                        .state{
                            position: absolute;
                            width: 105px;
                            height: 38px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 4px;
                            right: 20px;
                        }
                        .state.blue{
                            background-color: rgba(113, 170, 229, 0.1);
                            color: #71aae5;
                        }
                        .state.red{
                            background-color: rgba(240, 90, 62, 0.1);
                            color: #fc7171;
                        }
                        .state.gray{
                            background-color: #f3f3f3;
                            color: #676362;
                        }
                    }
                    .list{
                        display: flex;
                        padding-left: 20px;
                        margin-bottom: 16px;
                    }
                    .title{
                        width: 56px;
                        // color: #a8a5a4;
                        margin-right: 4px;
                        display: inline-flex;
                    }
                    .content{
                        display: flex;
                        .num{
                            display: block;
                            width: 51px;
                            text-align: right;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 424px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/BillDetail.vue